<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          :max-width="50"
          contain
          :src="require(`@/assets/conectiontab/salesforce-logo.png`)"
          :class="'mx-3 mt-4'"
        />
        <h2
          style="line-height:85px;"
          class="mr-3 mt-2"
        >
          Salesforce Integrations
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          v-track="`close-salesforce-detail-drawer`"
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <v-card
        outlined
        class="update-card mb-5"
      >
        <v-row class="px-3 pt-3">
          <v-col cols="1">
            <v-icon
              color="#3FD06F"
              class="mr-3"
              style="font-size:35px;"
            >
              mdi-checkbox-marked-circle
            </v-icon>
          </v-col>
          <v-col class="ml-1">
            <v-row><h2>Integration Added</h2> </v-row>
            <v-row class="mt-2 pr-2">
              <p>
                You just added the Salesforce integration.
                We are syncing the data right now and you should check back in a few minutes.
                As you continue to use Ultra Cart, We will automatically keep that data in sync with Maropost.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <div :id="`salesforce-intergration-details`">
        <h2>Integration Info</h2>
        <v-sheet
          v-if="isLoading"
          class="pa-3"
        >
          <v-skeleton-loader
            class="mx-auto"
            type="article"
            :loading="isLoading"
          />
        </v-sheet>
        <div
          v-else
          class="mt-5 mb-5 py-2 px-3 bg-grey"
        >
          <v-row
            v-if="storeData.name"
            class="py-2"
          >
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Name
            </v-col>
            <v-col class="py-0">
              {{ storeData.name }}
            </v-col>
          </v-row>

          <v-row
            v-if="storeData.username"
            class="py-2"
          >
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              User Name
            </v-col>
            <v-col class="py-0">
              {{ storeData.username }}
            </v-col>
          </v-row>

          <v-row
            v-if="storeData.password"
            class="py-2"
          >
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Password
            </v-col>
            <v-col class="py-0">
              ************
            </v-col>
          </v-row>
          <v-row
            v-if="storeData.api_key"
            class="py-2"
          >
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              API Key
            </v-col>
            <v-col class="py-0">
              {{ storeData.api_key }}
            </v-col>
          </v-row>
          <v-row
            v-if="storeData.salesforce_mode"
            class="py-2"
          >
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Display Mode
            </v-col>
            <v-col class="py-0">
              {{ storeData.salesforce_mode }}
            </v-col>
          </v-row>
          <v-row
            v-if="storeData.maropost_api_key"
            class="py-2"
          >
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Maropost API Key
            </v-col>
            <v-col class="py-0">
              {{ storeData.maropost_api_key }}
            </v-col>
          </v-row>
          <v-row class="py-2">
            <v-col
              cols="3"
              class="py-0 font-weight-light"
            >
              Status
            </v-col>
            <v-col class="py-0">
              <v-chip
                color="success"
                outlined
                small
              >
                Active
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </div>
      <v-btn
        v-track="`salseforce-store-index`"
        dark
        class="mt-5"
        @click="navigateIndexPage()"
      >
        Done
      </v-btn>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'SalesforceDetailDrawer',
    data () {
      return {
        isLoading: false,
        fields: {},
        storeData: {},
        Fields: [],
        isMounted: false,
      }
    },
    mounted () {
      this.isLoading = true
      if (this.$store.getters['ui/drawer'].right.storeData.data &&
        this.$store.getters['ui/drawer'].right.storeData.data.id
      ) {
        const data = this.$store.getters['ui/drawer'].right.storeData.data
        this.storeData = data
      }
      this.isLoading = false
      this.isMounted = true
    },
    beforeDestroy () {
      this.isMounted = false
      this.navigateIndexPage()
    },
    methods: {
      navigateIndexPage () {
        localStorage.removeItem('selected_integration_list_name')
        this.$router.push({
          name: 'Salesforce_index',
          query: { t: new Date().getTime() },
        })
      },
    },
  }
</script>

<style scoped>
.bg-grey {
  background-color: #f4f4f4;
}
.update-card{
  border: 1px solid #3BCF6C !important;
}
.field-table{
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
